import { Location } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ActiveTab, SessionData, Sessions } from './util';

@Component({
  selector: 'app-activity-log',
  templateUrl: './activity-log.component.html',
  styleUrls: ['./activity-log.component.scss']
})
export class ActivityLogComponent implements OnInit {
  @Input() vehicleId: string = '';
  expandedSession: string | null = null;
  activeSessionKey: string = '';
  activeSession: Sessions[] = null;
  isDrawerOpen = false;
  domain: string = environment.domain;
  imageBasePath: string = environment.base_path + 'storage/gallery/images/';
  activeTab: ActiveTab = 'INFORMATION';
  isLoading: boolean = false;
  apiError: boolean = false;
  logExists: boolean = false;
  sessions: SessionData = {};
  showPreviousPreview = false;
  showUpdatedPreview = false;

  constructor(private httpClient: HttpClient, private location: Location) {}

  ngOnInit(): void {}

  private setActiveTab(): void {
    const validTabs: ActiveTab[] = ['INFORMATION', 'OPTIONS', 'FLAGS', 'GALLERY'];
    const fullUrl = this.location.path();
    const urlSegments = fullUrl.split('/').filter((segment) => segment);

    const foundTab = validTabs.find((tab) => urlSegments.includes(tab.toLowerCase()));
    this.activeTab = foundTab || 'INFORMATION';
  }

  toggleSession(session: string): void {
    this.expandedSession = this.expandedSession === session ? '' : session;
  }

  setActiveSession(sessionKey: string, session: Sessions[]): void {
    this.activeSessionKey = sessionKey;
    this.activeSession = session;
  }

  toggleDrawer(): void {
    this.isDrawerOpen = !this.isDrawerOpen;

    if (this.isDrawerOpen) {
      document.body.style.overflow = 'hidden';
      this.setActiveTab();
      this.fetchLogs();
    } else {
      document.body.style.overflow = '';
    }
  }

  setTab(tabId: ActiveTab): void {
    this.activeTab = tabId;
    this.fetchLogs();
  }

  handleBackdropClick(event: MouseEvent): void {
    if (!(event.target as HTMLElement).closest('.drawer-content')) {
      this.toggleDrawer();
    }
  }

  fetchLogs() {
    this.apiError = false;
    this.isLoading = true;

    const params = new HttpParams()
      .set('page_name', this.activeTab.toLowerCase())
      .set('vehicle_id', this.vehicleId);

    this.httpClient.get(environment.api + '/grouped-activity-logs', { params }).subscribe({
      next: (res) => {
        this.sessions = res?.['data'];
        this.isLoading = false;
        this.logExists = Object.keys(this.sessions).length > 0;

        if (this.logExists) {
          this.activeSessionKey = Object.keys(this.sessions)[0];
          this.activeSession = this.sessions[this.activeSessionKey];
        }
      },
      error: (error) => {
        this.apiError = true;
        console.log(error);
        this.isLoading = false;
      }
    });
  }

  truncateString(name: string, maxLength: number = 17): string {
    if (name.length > maxLength) {
      return name.substring(0, maxLength) + '...';
    }

    return name;
  }

  formatDate(dateStr: string): string {
    const date = new Date(dateStr);

    // Get formatted date
    const formattedDate = date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });

    // Get formatted time
    const formattedTime = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });

    return `${formattedDate.replace(/\//g, '.')} | ${formattedTime}`;
  }

  formatString(input: string): string {
    return input
      .replace(/_/g, ' ')
      .replace(/ id$/i, '')
      .replace(/(?:^|\s)([a-z])/g, (match) => match.toUpperCase());
  }

  showPreviewModal(type: 'previous' | 'updated'): void {
    if (type === 'previous') {
      this.showPreviousPreview = true;
    } else {
      this.showUpdatedPreview = true;
    }
  }

  hidePreviewModal(type: 'previous' | 'updated'): void {
    if (type === 'previous') {
      this.showPreviousPreview = false;
    } else {
      this.showUpdatedPreview = false;
    }
  }

  openImageInNewTab(imageUrl: string): void {
    window.open(imageUrl, '_blank');
  }
}
